"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardCost = void 0;
const vue_1 = require("vue");
const PreferencesManager_1 = require("./../PreferencesManager");
exports.CardCost = vue_1.default.component('CardCost', {
    props: {
        amount: {
            type: Number,
        },
        newCost: {
            type: Number,
        },
    },
    methods: {
        getClasses: function () {
            const classes = ['card-cost'];
            if (this.amount === undefined) {
                classes.push('visibility-hidden');
            }
            return classes.join(' ');
        },
        displayTwoCosts: function () {
            const showDiscount = PreferencesManager_1.PreferencesManager.loadBoolean('show_discount_on_cards');
            return this.newCost !== undefined && this.newCost !== this.amount && showDiscount;
        },
    },
    template: `
    <div>
        <div :class="getClasses()">{{ amount === null ? 0 : amount }}</div>
        <template v-if="displayTwoCosts()">
          <div class="card-cost-transition"></div>
          <div class="card-old-cost">{{ newCost }}</div>
        </template>
    </div>
    `,
});
//# sourceMappingURL=CardCost.js.map